import { css } from '@emotion/react'
import { HFlow, Icon, Text, Theme, useTheme } from 'bold-ui'
import { AccordionButton } from 'components/accordion/AccordionButton'
import { CriteriosVulnerabilidadeFamiliar } from 'graphql/types.generated'
import { Accordion, AccordionItem, AccordionItemPanel } from 'react-accessible-accordion'

import { CriteriosVulnerabilidadeFamiliarPanel } from './CriteriosVulnerabilidadeFamiliarPanel'

interface CriteriosProps {
  criterios: CriteriosVulnerabilidadeFamiliar
}

export const CriteriosVulnerabilidadeFamiliarAccordion = ({ criterios }: CriteriosProps) => {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Accordion allowZeroExpanded>
      <AccordionItem>
        <AccordionButton
          wrapperStyle={css`
            padding-bottom: 0;
          `}
          style={styles.button}
        >
          <HFlow alignItems='center' style={styles.heading} hSpacing={0.5}>
            <Icon icon='angleDown' style={styles.icon} />
            <Text fontWeight='bold' style={styles.headerText}>
              Critérios de vulnerabilidade familiar presentes
            </Text>
          </HFlow>
        </AccordionButton>
        <AccordionItemPanel css={styles.content}>
          <CriteriosVulnerabilidadeFamiliarPanel criterios={criterios} />
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  )
}

const createStyles = (theme: Theme) => ({
  button: css`
    position: relative;
    border: 1px solid ${theme.pallete.gray.c80};
    background-color: ${theme.pallete.surface.main};
    border-radius: 0.25rem;
    margin: 0;
    min-height: auto;
  `,
  heading: css`
    padding: 0.8rem 1rem;
    margin: 0;
  `,
  headerText: css`
    font-size: 1rem;
    color: ${theme.pallete.text.main};
  `,
  icon: css`
    font-size: 1.2rem;
    color: ${theme.pallete.text.main};
  `,
  content: css`
    padding: 1.5rem 2rem;
    background-color: ${theme.pallete.surface.main};
    border: 1px solid ${theme.pallete.gray.c80};
    border-top: 0;
    border-radius: 0 0 0.25rem 0.25rem;
  `,
  list: css`
    margin: 0;
    padding: 0;
    list-style-type: disc;
  `,
  listItem: css`
    margin-bottom: 0.25rem;
    color: ${theme.pallete.text.main};
    &::marker {
      font-size: 0.75rem;
    }
  `,
})
